import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-src-settings-overlay',
  templateUrl: './src-settings-overlay.component.html',
  styleUrls: ['./src-settings-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SrcSettingsOverlayComponent {
  constructor() {}
}
